import ApiGateway from "../../explorer/services/ApiGateway";
import { endpoints } from "../configuration/endpoints";
import { CreateOrderWarrantyRequest, WarrantyItem, WarrantyItemForDamaged, WarrantyItemForMissing } from "../types";

export class WarrantyService {

    public getBasketDetails = (
        brand: string,
        lang: string
    ): Promise<WarrantyItem[]> => {
        return new Promise<WarrantyItem[]>((resolve, reject) => {
            ApiGateway()
                .get<WarrantyItem[]>(
                    endpoints.warranty.getItems
                        .replace("{brand}", brand) +
                    "?lang=" +
                    lang
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public createOrderWarranty = (
        warrantyRequest: CreateOrderWarrantyRequest,
        brand: string
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post(endpoints.warranty.createOrderWarranty.replace("{brand}", brand), warrantyRequest)
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    }
}